import React from "react";

function Loader() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        zIndex: "1000",
      }}
    >
      <svg className='tsvg' viewBox='25 25 50 50'>
        <circle r='20' cy='50' cx='50'></circle>
      </svg>
    </div>
  );
}

export default Loader;
